<template>
  <Modal
    :show="show"
    width="380"
    action-text="Send Email"
    @close="close"
    @action="notify"
  >
    <template #title>
      <v-tabs
        v-model="selectedTab"
        hide-slider
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :ripple="false"
        >
          <h5>
            {{ tab.title }}
          </h5>
        </v-tab>
      </v-tabs>
    </template>

    <template #content>
      {{ tabs[selectedTab].content }}
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/shared/Modal.vue';

export default {
  name: 'NotifyModal',
  components: { Modal },
  props: {
    show: { type: Boolean, default: false },
    user: { type: Object, default: () => ({}) },
  },
  emits: ['close', 'notify'],
  data() {
    return {
      selectedTab: 0,
    };
  },
  computed: {
    tabs() {
      return [{
        title: 'Request Edits',
        content: `Send ${this.user?.name || 'a team member'} an email inviting them to edit this job.`,
      }, {
        title: 'Notify',
        content: `Send ${this.user?.name || 'a team member'} an email notifying them that you have finished editing this job.`,
      }];
    },
  },
  methods: {
    close() {
      this.selectedTab = 0;
      this.$emit('close');
    },
    notify() {
      this.$emit('notify', {
        userId: this.user.id,
        type: this.selectedTab + 1,
        name: this.user.name,
      });
      this.selectedTab = 0;
    },
  },
};
</script>
<style lang="less" scoped>
:deep(.v-tabs) {
  height: unset;
}

.v-tab {
  color: @text-light;
}
.v-tab--selected {
  color: @text-darkest;
}
.v-tab {
  padding: 0;
  text-transform: none;
  :deep(.v-btn__underlay), :deep(.v-btn__overlay) {
    background-color: transparent !important;
  }
}
</style>
